module.exports = {"TXTWCL_Loading_cashier":{"id":"TXTWCL_Loading_cashier","defaultMessage":"正在载入出纳柜台"}}